import { RenderTargetWrapper } from "../renderTargetWrapper";

/** @hidden */
export class WebGPURenderTargetWrapper extends RenderTargetWrapper {
    /** @hidden */
    public _defaultAttachments: number[];
}
